"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = _interopRequireDefault(require("./"));

var _Loader = require("../Loader");

var _Constant = require("../Constant");

var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));

var _Typography = require("../Typography");

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  text-align: right;\n  margin: 5px 0 0 auto;\n  max-width: 75%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 40px 0;\n  padding: 0 40px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: 2px solid ", ";\n  border-top: 2px solid ", ";\n  height: 24px;\n  width: 24px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TextContainer = _styledComponents.default.div(_templateObject());

var Spinner = (0, _styledComponents.default)(_Loader.Spinner)(_templateObject2(), _Constant.Color.TEAL, _Constant.Color.SPIN_GREY);

var SpinnerContainer = _styledComponents.default.div(_templateObject3());

var Header = _styledComponents.default.h1(_templateObject4());

var SubHeader = _styledComponents.default.h2(_templateObject5());

var CarouselContainer = (0, _styledComponents.default)(_nukaCarousel.default)(_templateObject6());

var CarouselHeader = _styledComponents.default.h2(_templateObject7());

var Legal = (0, _styledComponents.default)(_Typography.Typography.SmallBodyGrey)(_templateObject8());
/**
 * A modal to show income processing
 *
 * TODO(aromero): Remove nuka-carousel as dev and peer dependency and move to deps when
 * https://github.com/WICG/inert/pull/157 is merged in and nuka-carousel version is updated.
 *  */

var ProcessingModal = function ProcessingModal(_ref) {
  var isOpen = _ref.isOpen,
      closable = _ref.closable,
      header = _ref.header,
      subheader = _ref.subheader,
      carouselHeaders = _ref.carouselHeaders,
      disclaimers = _ref.disclaimers,
      speed = _ref.speed;
  return /*#__PURE__*/_react.default.createElement(_.default, {
    size: "lg",
    isOpen: isOpen,
    closable: closable,
    description: header,
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement(SpinnerContainer, null, /*#__PURE__*/_react.default.createElement(Spinner, null)), /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(Header, null, header), carouselHeaders.length === 0 ? /*#__PURE__*/_react.default.createElement(SubHeader, null, subheader) : /*#__PURE__*/_react.default.createElement(CarouselContainer, {
    autoplay: true,
    withoutControls: true,
    wrapAround: true,
    autoplayInterval: speed
  }, carouselHeaders.map(function (c) {
    return /*#__PURE__*/_react.default.createElement(CarouselHeader, {
      key: c.key
    }, c.value);
  })), disclaimers.length > 0 && disclaimers.map(function (d) {
    return /*#__PURE__*/_react.default.createElement(Legal, {
      key: d.key
    }, d.value);
  })));
};

ProcessingModal.propTypes = {
  /** Is the modal open? */
  isOpen: _propTypes.default.bool,
  closable: _propTypes.default.bool,
  header: _propTypes.default.string,
  subheader: _propTypes.default.string,
  carouselHeaders: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    value: _propTypes.default.node.isRequired
  })),
  disclaimers: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    value: _propTypes.default.node.isRequired
  })),
  speed: _propTypes.default.number
};
ProcessingModal.defaultProps = {
  isOpen: false,
  closable: false,
  header: 'We are retrieving information from your provider.',
  subheader: 'Please do not refresh the page, sometimes this can take up to a minute. Thank you for your patience.',
  carouselHeaders: [],
  disclaimers: [],
  speed: 3000
};
var _default = ProcessingModal;
exports.default = _default;